const updateRangeProgress = (range) => {
  const min = parseFloat(range.min || 0)
  const max = parseFloat(range.max || 100)
  const value = parseFloat(range.value)
  const percent = (value - min) / (max - min) * 100

  range.style.setProperty('--progress-width', `${percent}%`);
  range.dataset.percent = percent;
}

const initRangeFromSelect = (select) => {
  if (select.dataset.rangeInitialized) return
  select.dataset.rangeInitialized = true

  const choices = Array.from(select.querySelectorAll('option'), (option) => {
    return { value: option.value, label: option.textContent }
  })

  const range = document.createElement('input')
  range.type = 'range'
  range.classList.add('form-control')
  range.min = 0
  range.max = choices.length - 1
  range.step = 1
  range.value = select.querySelectorAll('option[selected]').index
  range.addEventListener('input', () => select.value = choices[range.value].value)
  initRange(range)

  select.style.display = 'none'
  select.parentNode.insertBefore(range, select.nextSibling);
}

const initRange = (range) => {
  if (range.dataset.rangeInitialized) return
  range.dataset.rangeInitialized = true

  range.addEventListener('input', () => updateRangeProgress(range))
  updateRangeProgress(range)
}

const initRanges = (target) => {
  target.querySelectorAll('input[type="range"].form-control').forEach(initRange)
  target.querySelectorAll('select[data-control="range"]').forEach(initRangeFromSelect)
}

const attachAll = () => {
  initRanges(document)

  const observer = new MutationObserver((mutations) => {
    mutations.filter((m) => m.addedNodes.length > 0).forEach((mutation) => {
      initRanges(mutation.target)
    })
  })

  observer.observe(document.body, {
    childList: true,
    subtree: true
  })
}

export default {
  attachAll
}
